import type { UnknownOutputParams } from 'expo-router'
import { create } from 'zustand/react'

import { useSearchParamsAction } from '@/src/general/hooks/useSearchParamsAction'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

import { getIsLoggedIn } from '../utils/getIsLoggedIn'

export const useEmailHashStore = create<{ emailHash?: string; setEmailHash: (emailHash: string) => void }>((set) => ({
  emailHash: undefined,
  setEmailHash: (emailHash: string) => set({ emailHash }),
}))

export const useEmailHash = (searchParams: UnknownOutputParams) => {
  const { emailHash: storedEmailHash, setEmailHash } = useEmailHashStore()

  useSearchParamsAction({
    searchParams,
    action: ({ emailHash }) => {
      if (typeof emailHash === 'string' && emailHash && !getIsLoggedIn()) setEmailHash(emailHash)
    },
    requestedQuery: { emailHash: (value) => !!value },
    keepQueryParams: true,
  })

  const { emailHash: emailHashSearchParam } = filterSearchParams(searchParams)

  return getIsLoggedIn() ? undefined : emailHashSearchParam || storedEmailHash
}
